import RoundButton from 'Components/RoundButton';
import TipContent from 'Components/Tooltip';
import { Box, Button, Tip } from 'grommet';
import { SmilePlus } from 'lucide-preact';

import { getDesktopOrMobile } from '../../../../../helpers';
import style from './style.scss';

const EmojiButton = ({ plain, onClick }) => {
  const device = getDesktopOrMobile();
  return (
    <div className="pt-0.5">
      {plain && (
        <Button plain onClick={onClick}>
          <SmilePlus color="#fff" size={22} />
        </Button>
      )}
      {!plain &&
        (device === 'mobile' ? (
          <Box>
            <RoundButton
              onClick={onClick}
              className={style.emojiButton}
              width="36"
              backgroundColor="var(--secondaryGreen)"
              color="white"
            >
              <SmilePlus size={22} />
            </RoundButton>
          </Box>
        ) : (
          <Tip dropProps={{ align: { left: 'right' } }} content={<TipContent message="Add Emoji Reactions" />} plain>
            <Box>
              <RoundButton
                onClick={onClick}
                className={style.emojiButton}
                width="36"
                backgroundColor="var(--secondaryGreen)"
                color="white"
              >
                <SmilePlus size={22} />
              </RoundButton>
            </Box>
          </Tip>
        ))}
    </div>
  );
};

export default EmojiButton;
